import React, { forwardRef } from 'react'
import cx from 'classnames'
import * as Icon from '@manychat/icons'

import cleanProps from '../../lib/clean-react-props'
import Loader from '../Loader'

import { ButtonRoundProps, IconNames, IconSizes } from './interfaces'

import cm from './ButtonRound.module.css'

export const sizeMapping: Record<IconSizes, number> = {
  default: 20,
  small: 16,
  large: 24,
}

export const ButtonRound = forwardRef<HTMLButtonElement, ButtonRoundProps>(
  ({ disabled, loading, size = 'default', ariaLabel, className, onClick, icon, ...props }, ref) => {
    const IconComponent = Icon[icon as IconNames]
    const iconSize = sizeMapping[size]

    const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      if (disabled || loading) {
        event.preventDefault()
        return
      }
      onClick?.(event)
    }

    return (
      <button
        ref={ref}
        disabled={disabled}
        aria-label="ariaLabel"
        aria-disabled={disabled || false}
        onClick={handleClick}
        className={cx(
          cm.buttonRound,
          {
            [cm.loading]: loading,
          },
          className,
        )}
        {...cleanProps(props, [], [])}
      >
        {loading && (
          <span className={cx(cm.loader)}>
            <Loader center size={iconSize} theme={{ spinner: cx(cm.spinner) }} />
          </span>
        )}
        <IconComponent aria-hidden="true" focusable="false" size={iconSize} />
      </button>
    )
  },
)
